import { lazy } from 'react';

export const ChangePasswordFormAsync = lazy(() =>
  import('./ChangePasswordForm').then((m) => ({ default: m.ChangePasswordForm })),
);
